<template>
   <div class="pdd-box">
     <!--<headerTab></headerTab>-->
     <div @click="$router.push('/pdd/search')">
<vueSearch></vueSearch>
     </div>
     <van-tabs @click="onTabChange" v-model="active">
        <van-tab title="精选">
      </van-tab>
      <van-tab v-for="(item,index) in catList" :title="item.opt_name" :key="index">
      </van-tab>
      </van-tabs>
      <recommendList></recommendList>
      <div class="good-list">
        <good v-for="(item,index) in goodList"
      :key="index" :good="item"></good>
      </div>
    <van-button type="default" size="large" v-show="page*20<total_results" @click="loadMore">加载更多</van-button>
   </div>
</template>

<script>
  import good from '../../components/pdd/good'

export default {
  data () {
    return {
     active:0,  //分类索引
     sortType:'',//排序
     keyword:'',  //搜索词
     optId:'', //分类id
     goodList:[],  //商品列表
      total_results: 100, //总页数
      page: 1,
      catList:[], //分类列表
    }
  },
  components:{
    good,
  },
  created(){
      const pddCat = window.localStorage.getItem('pddCat')
      if(pddCat){
this.catList = JSON.parse(pddCat);
      }else{
     this.Post({
      },'/pdd',(res)=>{
        if(res.states==1){
          this.catList=res.data.goods_opt_get_response.goods_opt_list;
          window.localStorage.setItem('pddCat',JSON.stringify(this.catList));
        }
      })
      }
      this.getData();
  },
  methods:{
    // 获取数据
    getData(data){
      this.Post(data,'/pdd/api_goods_search',(res)=>{
        if(res.states==1){
          let good = res.data.goods_search_response.goods_list;
          const list= this.goodList
          this.goodList = [...list,...good];
          this.total_results = Number(res.data.goods_search_response.total_count);
        }
      })
    },
     // 搜索
    onSearch(keyword) {
      this.goodList = [];
      this.page = 1;
      this.total_results=0;
      this.keyword = keyword;
      let data = {
        q: this.keyword,
        opt_id:this.optId
      };
      this.getData(data);
    },
    // 分类搜索
    onTabChange(index,title){
      this.active=index;
      let optId=0;
      if(index>0){
        optId=this.catList[index-1].opt_id;
        this.optId = optId
      }
      let data = {
        q: this.keyword,
        opt_id:optId
      };
      this.page = 1;
      this.total_results=0;
      this.goodList = [];
      this.getData(data);
    },
      // 排序筛选
    doSort(index, title) {

    },
     // 加载更多
    loadMore() {
      if (this.page * 20 < this.total_results) {
        this.page++;
        let data = {
          page: this.page,
          q: this.keyword,
          opt_id:this.optId
        };
        this.getData(data);
      }
    },
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
   .pdd-box{
     .good-list{
       padding-top: 5px;
     }
   }
</style>



// WEBPACK FOOTER //
// src/pages/pdd/index.vue